import { IResponse } from '../interfaces/common-interfaces';

export const DEFAULT_ERROR = 'An error has occurred.';

/**
 * encode and format the data
 */
export const encodeData = (data: any) => {

    const params = [];

    for(let key in data) {
        if (data.hasOwnProperty(key)) {
            params.push(key + '=' + window.encodeURIComponent(data[key]));
        }
    }

    return params.join('&');
};

/**
 * Returns true if access is denied.
 */
const ifShouldDenyOnReadOnly = async (response: Response|null) => {
    if(response?.status !== 999) return false;
    window.location.href = '/maintenance';

    /*
    let isLoggedIn = false;

    try{
        // {"message":"Waves.com is undergoing maintenance.","isLoggedIn":false}
        const text = await response.text();
        const parsed = JSON.parse(text);
        isLoggedIn = parsed.isLoggedIn;
        if(isLoggedIn){
            window.location.href = '/maintenance';
        }
    }
    catch(ex){
        console.log(ex);
    }*/

    return true;
};

/**
 * get request
 */
export const get = async (url: string, data: any = null) : Promise<IResponse> => {

    if(data){

        const qs = encodeData(data);
        url += `?${qs}`;
    }

    const headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('Content-Type', 'application/json');

    const response = await fetch(url, {
        method: 'GET',
        headers,
        credentials: 'same-origin' //'include', 'omit'
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    return {
        data: await response.json(),
        statusCode: response.status
    }
};

/**
 * post request
 */
export const post = async (url: string, data: any) : Promise<IResponse> => {

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    return {
        data: await response.json(),
        statusCode: response.status
    }
};

export const del = async (url: string, data: any) : Promise<IResponse> => {

    const response = await fetch(url, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    return {
        data: await response.json(),
        statusCode: response.status
    }
};

export const put = async (url: string, data: any) : Promise<IResponse> => {

    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    return {
        data: await response.json(),
        statusCode: response.status
    }
};

/**
 * upload file
 */
export const upload = async (url: string, data: FormData, headers?: any) => {

    let response: Response | null = null;
    const config: RequestInit = {
        method: 'POST',
        body: data
    };

    if(headers){
        config.headers = headers;
    }

    try{
        response = await fetch(url, config);
    }
    catch(ex){
        console.log('Error:', ex);
    }

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    return {
        data: await response?.json(),
        statusCode: response?.status
    }
};

export const download = (fileName: string, blob: Blob) => {
    const url = window.URL.createObjectURL(blob);
    const $a = document.createElement('a');
    $a.style.display = 'none';
    $a.href = url;
    // the filename you want
    $a.download = fileName;
    document.body.appendChild($a);
    $a.click();
    window.URL.revokeObjectURL(url);
};

export const getDownload = async (fileName: string, url: string, data: any = null) => {

    if(data){

        const qs = encodeData(data);
        url += `?${qs}`;
    }

    const headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('Content-Type', 'application/json');

    const response = await fetch(url, {
        method: 'GET',
        headers,
        credentials: 'same-origin' //'include', 'omit'
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    const blob = await response.blob();
    download(fileName, blob);
};

export const postDownload = async (fileName: string, url: string, data: any = null) => {

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if(await ifShouldDenyOnReadOnly(response)){
        throw new Error('Waves.com is undergoing maintenance.');
    }

    const blob = await response.blob();
    download(fileName, blob);
};


